import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://glxonqxvyhugihaakedd.supabase.co';
const supabaseKey = 'sb_publishable_-6_NCkRxWhd8L1TqbLDidw_DMFcfpRe';

export const supabase = createClient(supabaseUrl, supabaseKey);
